import React from 'react'
 
const SeperatedBar = () => {
    return (
        <div className="separate">
            <div className="br-line"></div>
        </div>
    );
};
 
export default SeperatedBar;